import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { useI18n } from '@/hooks/useI18n';
import { Sidebar } from './Sidebar';

export function MobileNavigation() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 1024px)');
    const closeOnDesktop = () => {
      if (desktop.matches) setOpen(false);
    };
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          aria-label={t('Ouvrir le menu', 'Open menu')}
          className="flex size-11 shrink-0 items-center justify-center rounded-[10px] border border-line-1 bg-bg-1 text-text-1 lg:hidden"
        >
          <Menu className="size-5" />
        </button>
      </DialogTrigger>
      <DialogContent
        aria-describedby={undefined}
        className="left-0 top-0 flex h-dvh max-h-dvh w-[min(320px,calc(100vw-32px))] max-w-none translate-x-0 translate-y-0 flex-col gap-0 rounded-none border-y-0 border-l-0 p-0 data-[state=closed]:zoom-out-100 data-[state=open]:zoom-in-100 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left"
      >
        <DialogTitle className="sr-only">
          {t('Navigation principale', 'Main navigation')}
        </DialogTitle>
        <Sidebar
          collapsed={false}
          mobile
          onToggle={() => setOpen(false)}
          onNavigate={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
